import React from 'react';
import { createPortal } from 'react-dom';

// プロダクト全体で共通利用する「準備しています」ローディングの単一実装。
//
// 過去の問題:
//   ・チャット導線（ルート解決・初回ブート・ステップ内ローディング）と
//     App.js のグローバル(axios)ローディングがそれぞれ別マークアップを持ち、
//     「全画面（クリーム地）」と「ソフトオーバーレイ（暗転＋白カード）」の
//     2 種類の見た目が混在 → 予約導線の遷移ごとに切り替わってチラついていた。
//
// 方針:
//   ・スピナー / 文言 / ドットの見た目はこのコンポーネントへ完全集約し、
//     どこから呼んでも同一の視覚要素にする。
//   ・出し分けは variant のみ:
//       - 'fullscreen': 画面に何も無いブート時（アプリ起動・ルート解決）。
//       - 'overlay'   : 既に画面がある状態の遷移中（設問送信・前後遷移など）。
//     これにより「ブートは全画面」「フロー中はソフトオーバーレイ」で固定され、
//     フロー中に全画面とオーバーレイが交互に出るチラつきが起きない。
function ChatLoadingScreen({ variant = 'fullscreen' }) {
  const content = (
    <div className="mc-loading-content">
      <div className="mc-loading-spinner" />
      <p className="mc-loading-text">
        準備しています
        <span className="mc-loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </p>
    </div>
  );

  if (variant === 'overlay') {
    const overlay = (
      <div
        className="mc-soft-loading-overlay"
        role="status"
        aria-live="polite"
        aria-label="準備しています"
        style={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          visibility: 'visible',
          pointerEvents: 'all',
        }}
      >
        {content}
      </div>
    );
    return typeof document !== 'undefined' ? createPortal(overlay, document.body) : overlay;
  }

  return (
    <div
      className="mc-loading-screen mc-loading-screen--fade"
      role="status"
      aria-live="polite"
      aria-label="準備しています"
    >
      {content}
    </div>
  );
}

export default ChatLoadingScreen;
